class WbTippy {
  constructor() {}

  init() {
    return new Promise((resolve) => {
      tippy('[data-tippy-content]');
      resolve();
    });
  }
}

window.WbTippy = new WbTippy();
BarbaController.addObject(WbTippy);
